const messages = {
	signUpSuccess: "Successfully registered! You've been signed in as well.",
	signUpFailure:"Registration failed. Email may be taken, or passwords don't match.",
	signInSuccess: 'Welcome!',
	signInFailure:'Failed to sign in. Check your email and password and try again.',
	signOutSuccess: 'Come back soon!',
	changePasswordSuccess: 'Password changed successfully!',
	changePasswordFailure:'Failed to change passwords. Check your old password and try again.',
	getSongsFailure: 'Error fetching songs.',
	getMessageFailure: 'Error fetching posts.',
	createSongSuccess: 'Song created Successfully!',
	createSongFailure: 'Something went wrong, please try again.',
	updateSongSuccess: 'Song updated Successfully!',
	updateSongFailure: 'Could not update song, something went wrong.',
	removeSongSuccess: 'Song remove Successfully!',
	removeSongFailure: 'Could not remove song, something went wrong.',
	removeMessagegSuccess: 'Message remove Successfully!',
	removeMessageFailure: 'Could not remove message, something went wrong.',
	createMessageSuccess: 'Post created Successfully!',
	createMessageFailure: 'Something went wrong, please try again.',

}

module.exports = messages